/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole word only`)
};

const es_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo palabras completas`)
};

const de_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ganze Wörter`)
};

const nl_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen hele woorden`)
};

const fr_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot entier uniquement`)
};

const it_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo parola intera`)
};

const pt_br2_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas palavra completa`)
};

const pt_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas palavras inteiras`)
};

const ja_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語全体のみ`)
};

const zh_fr_whole_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅匹配整个单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_whole_word = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_whole_word(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_whole_word", locale)
	if (locale === "en") return en_fr_whole_word(inputs)
	if (locale === "es") return es_fr_whole_word(inputs)
	if (locale === "de") return de_fr_whole_word(inputs)
	if (locale === "nl") return nl_fr_whole_word(inputs)
	if (locale === "fr") return fr_fr_whole_word(inputs)
	if (locale === "it") return it_fr_whole_word(inputs)
	if (locale === "pt-BR") return pt_br2_fr_whole_word(inputs)
	if (locale === "pt") return pt_fr_whole_word(inputs)
	if (locale === "ja") return ja_fr_whole_word(inputs)
	return zh_fr_whole_word(inputs)
};